import React from "react";
import StatTile, {classifyExpression} from "../StatTile";
import {LibraryModalResult} from "../../types/list";

const GeneExpressionFitness = ({libraryData}: {libraryData: LibraryModalResult}) => {
  const expression = classifyExpression(libraryData.expression);
  const essentiality = libraryData.essential ? "Essential" : "Non-essential";
  const fitnessLabel = (() => {
    if (essentiality === "Essential") return "Defect";
    return libraryData.fitness === "No Fitness Phenotype" ? "None" : libraryData.fitness || undefined;
  })();
  const mfVar = libraryData.variability === "High" ? "High (var)" : libraryData.variability;

  return (
    <>
      <h6 className="section-label border-warning">HAP1 Gene Expression & Fitness</h6>
      <div className="row g-2">
        <StatTile title="Gene expression" subtitle="log₂(TPM+1)" label={expression} value={libraryData.expression?.toFixed(2)}/>
        <StatTile title="Gene essentiality" label={essentiality}/>
        <StatTile title="Mutant fitness (MF)" subtitle="LFC" label={fitnessLabel} value={libraryData.fitness_rich}/>
        <StatTile title="MF variability" label={mfVar}/>
      </div>
    </>
  );
};

export default GeneExpressionFitness;